document.addEventListener('DOMContentLoaded', () => {

  /* ===============================
     UTIL FUNCTIONS
  =============================== */

  function applyGrid(gridType) {
    const productGrid = document.querySelector('.product-grid');
    if (!productGrid) return;

    productGrid.classList.toggle('grid-medium', gridType === 'medium');
  }

  function restoreGrid() {
    const gridType = sessionStorage.getItem('gridType') || 'medium';
    applyGrid(gridType);

    // Restore active button state
    document.querySelectorAll('.two-row-btn, .one-row-btn').forEach(btn => {
      btn.classList.toggle('is-active', btn.value === gridType);
    });
  }

  /* ===============================
     BUTTON CLICK (Mobile + Desktop)
  =============================== */

  document.addEventListener('click', (e) => {
    const button = e.target.closest('.two-row-btn, .one-row-btn');
    if (!button) return;

    const wrapper = button.closest('.mbl-grid-btn, .dsk-grid-btn');
    if (!wrapper) return;

    wrapper.querySelectorAll('.two-row-btn, .one-row-btn')
      .forEach(btn => btn.classList.remove('is-active'));

    button.classList.add('is-active');

    const gridType = button.value; // medium / default
    sessionStorage.setItem('gridType', gridType);
    applyGrid(gridType);
  });

  /* ===============================
     INITIAL LOAD
  =============================== */

  restoreGrid();

  /* ===============================
     OBSERVE FILTER AJAX RERENDER
  =============================== */

  const gridContainer =
    document.querySelector('#ProductGridContainer') ||
    document.querySelector('.product-grid') ||
    document.body;

  const observer = new MutationObserver(() => {
    restoreGrid();
  });

  observer.observe(gridContainer, {
    childList: true,
    subtree: true
  });

});


$(document).ready(function() {
    // Generate unique session ID (lasts 24 hours)
    function getOrCreateSessionId() {
        let sessionId = localStorage.getItem('shopifyUserSessionId');
        let sessionExpiry = localStorage.getItem('sessionExpiry');
        const now = Date.now();
        
        // Create new session if expired or doesn't exist
        if (!sessionId || !sessionExpiry || now > parseInt(sessionExpiry)) {
            sessionId = 'user_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
            localStorage.setItem('shopifyUserSessionId', sessionId);
            localStorage.setItem('sessionExpiry', (now + (24 * 60 * 60 * 1000)).toString()); // 24 hours
            
            // Clear old session data
            sessionStorage.removeItem('myProducts');
            console.log('New session created:', sessionId);
        } else {
            console.log('Existing session:', sessionId);
        }
        
        return sessionId;
    }

    const sessionId = getOrCreateSessionId();
    
    // Flag to prevent cleanup while adding to cart
    var _twdAddingToCart = false;
    
    // Store my created products
    function getMyProducts() {
        return JSON.parse(sessionStorage.getItem('myProducts') || '[]');
    }
    
    function addMyProduct(productId, variantId) {
        const products = getMyProducts();
        products.push({
            productId: productId,
            variantId: variantId,
            sessionId: sessionId,
            createdAt: new Date().toISOString()
        });
        sessionStorage.setItem('myProducts', JSON.stringify(products));
        console.log('Product added to my list:', productId);
    }
    
    function clearMyProducts() {
        sessionStorage.removeItem('myProducts');
    }

    // Check if my products are in cart
    async function areMyProductsInCart() {
        const myProducts = getMyProducts();
        if (myProducts.length === 0) return false;
        
        try {
            const cart = await $.getJSON('/cart.js');
            const myVariantIds = myProducts.map(p => p.variantId.toString());
            
            return cart.items.some(item => 
                myVariantIds.includes(item.variant_id.toString())
            );
        } catch (error) {
            console.error('Error checking cart:', error);
            return false;
        }
    }

    // Delete only MY session products
    function deleteMySessionProducts() {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: 'https://lightcoral-snake-102782.hostingersite.com/api/custom-api-delete-session-products',
                method: 'POST',
                data: { session_id: sessionId },
                dataType: 'json',
                success: function(response) {
                    console.log('My session products deleted:', response.message);
                    clearMyProducts();
                    resolve(response);
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    console.error('Error deleting my products:', textStatus, errorThrown);
                    reject(errorThrown);
                }
            });
        });
    }

    // Main product creation logic
    if($('body').hasClass('template-product')) {
        $('.product-form__buttons button[type="submit"]').click(function(event) {
            
            var checkInputField = $('#pack-quantity').val();
            var checkInputValue = $('#area-input').val();
            var $this = $(this);
            
            // Skip if this is the Order a Sample button
            if ($(this).closest('.sample-btn').length > 0 || $(this).closest('product-form.sample-btn').length > 0) {
                return; // Let native sample form handle it
            }

            if($('#area-input').length > 0 && checkInputValue != 1 && !$(this).hasClass('success')) {
                _twdAddingToCart = true;
                console.log('Creating product for session:', sessionId);
                window.isCreatingProduct = true;
                event.preventDefault();
                $('.load-more').attr('style', 'display: flex;');
                
                var getProTitle = $('.product__title h1').text().trim() || 'Custom Product';
                var getProImg = $('.main-prod-slider .thumbnail-img .swiper-slide-active .image-wrap img').attr('src') || $('.product__media img').attr('src') || '';
                var getProPrice = $('#pack-price-display').text() || $('.price-item--sale').text() || $('.price-item--regular').text() || '0';
                var priceMatch = getProPrice.match(/[\d.]+/);
                var numericValue = priceMatch ? parseFloat(priceMatch[0]) : 1.00;
                var proPacks = checkInputField || '1';
                var totalAreaPrice = numericValue;

                var data = {
                    title: getProTitle,
                    price: totalAreaPrice,
                    img: getProImg,
                    session_id: sessionId
                };

                $.ajax({
                    url: 'https://lightcoral-snake-102782.hostingersite.com/api/custom-api-create-product-session',
                    method: 'POST',
                    data: data,
                    dataType: 'json'
                })
                .done(function(response) {
                    if (response.product_id && response.variant_id) {
                        console.log('Product created successfully:', response);
                        addMyProduct(response.product_id, response.variant_id);

                        // Save current main product URL for redirection
                        sessionStorage.setItem('mainProductUrl_' + response.product_id, window.location.pathname);
                        sessionStorage.setItem('mainProductUrl_' + response.variant_id, window.location.pathname);
                        sessionStorage.setItem('lastMainProductUrl', window.location.pathname);

                        $('.load-more').hide();
                        
                        // Update form variant ID
                        $('.product-form:not(.sample-btn) .product-variant-id, .product-form:not(.sample-btn) input[name="id"]').val(response.variant_id);
                        
                        // Clean up existing properties to prevent duplicates
                        $('input[name="properties[Total Area]"]').remove();
                        $('input[name="properties[_main_product_url]"]').remove();
                        
                        var targetForm = $('.product-form:not(.sample-btn) form');
                        var calcArea = $('#total-area-property').val() || (checkInputValue ? checkInputValue + ' m²' : '0 m²');
                        targetForm.prepend('<input type="hidden" name="properties[Total Area]" value="' + calcArea + '">');
                        targetForm.prepend('<input type="hidden" name="properties[_main_product_url]" value="' + window.location.pathname + '">');
                        
                        // Set quantity
                        $('.product-form:not(.sample-btn) #Quantity, .product-form:not(.sample-btn) input[name="quantity"]').val(proPacks);
                        
                        // Trigger native theme submission
                        $this.addClass('success');
                        $this.click();

                        setTimeout(function() {
                            setTimeout(function() { window.isCreatingProduct = false; _twdAddingToCart = false; }, 10000);
                        }, 4000);
                    } else {
                        console.error('Product created but no IDs returned:', response);
                        setTimeout(function() { window.isCreatingProduct = false; _twdAddingToCart = false; }, 10000);
                        $('.load-more').hide();
                    }
                })
                .fail(function(jqXHR, textStatus, errorThrown) {
                    console.error('Failed to create product:', jqXHR.responseText || textStatus);
                    setTimeout(function() { window.isCreatingProduct = false; _twdAddingToCart = false; }, 10000);
                    $('.load-more').hide();
                });

            } else {
                $this.removeClass('success');
                setTimeout(function() {
                    setTimeout(function() { window.isCreatingProduct = false; _twdAddingToCart = false; }, 10000);
                }, 3000);
            }
        });
    }

    // Monitor cart and cleanup
    async function monitorCart() {
        if (window.isCreatingProduct) {
            console.log('Product creation in progress, skipping monitorCart check.');
            return;
        }
        try {
            const cart = await $.getJSON('/cart.js');
            const myProducts = getMyProducts();
            
            if (myProducts.length === 0) {
                return; // No products to track
            }
            
            if (cart.item_count === 0) {
                console.log('Cart empty, checking if I have products to delete...');
                // Cart is empty, delete my session products
                await deleteMySessionProducts();
            } else {
                // Check if MY products are still in cart
                const myVariantIds = myProducts.map(p => p.variantId.toString());
                const cartVariantIds = cart.items.map(item => item.variant_id.toString());
                
                const myProductsInCart = myVariantIds.some(variantId => 
                    cartVariantIds.includes(variantId)
                );
                
                if (!myProductsInCart) {
                    console.log('My products not in cart, deleting them...');
                    await deleteMySessionProducts();
                } else {
                    console.log('My products still in cart, keeping them.');
                }
            }
        } catch (error) {
            console.error('Error monitoring cart:', error);
        }
    }

    // Setup cart change listeners
    function setupCartMonitoring() {
        // Listen for Shopify cart updates
        $(document).on('ajaxComplete', function(event, xhr, settings) {
            if (settings.url && (
                settings.url.includes('/cart/update.js') || 
                settings.url.includes('/cart/change.js') ||
                settings.url.includes('/cart/add.js') ||
                settings.url.includes('/cart/clear.js')
            )) {
                if (!window.isCreatingProduct && !_twdAddingToCart) { setTimeout(monitorCart, 1000); }
            }
        });

        // Check on page load
        $(window).on('load', function() {
            if (!window.isCreatingProduct && !_twdAddingToCart) { monitorCart(); }
            
            // Periodic check every 2 minutes
            setInterval(monitorCart, 120000);
        });

        // Check before leaving page
        $(window).on('beforeunload', function() {
            if (!window.isCreatingProduct && !_twdAddingToCart && getMyProducts().length > 0) {
                try {
                    var cartResponse = $.ajax({url: '/cart.js', method: 'GET', async: false});
                    var cart = JSON.parse(cartResponse.responseText || '{}');
                    if (cart.item_count === 0) {
                        console.log('Page unloading, deleting my products via sendBeacon...');
                        var fd = new FormData();
                        fd.append('session_id', sessionId);
                        navigator.sendBeacon('https://lightcoral-snake-102782.hostingersite.com/api/custom-api-delete-session-products', fd);
                    }
                } catch(e) {
                    console.error('beforeunload error:', e);
                }
            }
        });
    }

    // Initialize
    setupCartMonitoring();

    // Initial cart check (replaces your original cookie-based check)
    $.getJSON('/cart.js', function(cart) {
        if (cart.item_count === 0 && !_twdAddingToCart) {
            console.log("Initial cart check: Cart is empty.");
            const myProducts = getMyProducts();
            if (myProducts.length > 0) {
                console.log('I have products but cart is empty, cleaning up...');
                deleteMySessionProducts();
            }
        } else {
            console.log("Initial cart check: Cart has items.");
        }
    });
});


document.addEventListener('DOMContentLoaded', () => {
  const SAMPLE_VARIANT_ID = '57045349499264'; // Change if different variants
  const MAX_SAMPLES = 3;
  const MESSAGE = 'You can only add a maximum of 3 samples to your cart.';

  async function getSampleCount() {
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      const sampleItem = cart.items.find(i => i.variant_id.toString() === SAMPLE_VARIANT_ID);
      return sampleItem ? sampleItem.quantity : 0;
    } catch (e) {
      return 0;
    }
  }

  // Target "Order a Sample" buttons (standard DOM traversal)
  const sampleButtons = Array.from(document.querySelectorAll('button, .product-form__submit, .sample-btn button')).filter((btn) => {
    return (
      btn.id?.startsWith('SampleSubmitButton') ||
      btn.closest('.sample-btn') !== null ||
      btn.textContent.includes('Order a Sample') ||
      btn.textContent.includes('Order free Sample')
    );
  });

  sampleButtons.forEach((btn) => {
    btn.closest('form')?.addEventListener('submit', async (e) => {
      const form = e.target;
      const variantInput = form.querySelector('input[name="id"]');
      if (!variantInput || variantInput.value !== SAMPLE_VARIANT_ID) return;

      const current = await getSampleCount();
      if (current >= MAX_SAMPLES) {
        e.preventDefault();
        e.stopPropagation();

        // Try theme's error display, fallback to alert
        const notification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (notification?.renderError) {
          notification.renderError(MESSAGE);
        } else {
          alert(MESSAGE);
        }
      }
    });
  });
});
